enum TextRuRequestStatus {
  AWAIT = 'await',
  READY = 'ready',
}

interface TextRuResponse {
  status: TextRuRequestStatus
  request: {
    article_id: number
    uid: string
    text: string
    updated_at: string
    created_at: string
    id: number
    uniqueness?: string
  }
}

export { TextRuRequestStatus }

export type { TextRuResponse }
